import { render, staticRenderFns } from "./subscribe.vue?vue&type=template&id=fd22d734&scoped=true&"
import script from "./subscribe.vue?vue&type=script&lang=ts&"
export * from "./subscribe.vue?vue&type=script&lang=ts&"
import style0 from "./subscribe.vue?vue&type=style&index=0&id=fd22d734&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd22d734",
  null
  
)

export default component.exports